export default __webpack_public_path__ + "static/media/cloud-logo-white.aa4b6994.svg";